<template>
  <el-select class="td_select"
             v-model="values"
             default-first-option
             filterable
             remote
             reserve-keyword
             :allow-create="allowCreate"
             placeholder="请输入项目名称"
             :remote-method="remoteMethod"
             :clearable="clearable"
             :disabled="disabled"
             :loading="loading"
             :multiple="multiple"
             @blur="blur"
             @change="change"
             @select="select"
             @visible-change="visible_change"
             @clear="handleClear">
    <el-option
      class="td_option"
      v-for="(item, index) in options"
      :key="index"
      :label="item.customerName"
      :value="item.customerName"
      @click.native="handleSelect(item)">
<!--      <span style="float: left; width: 260px;"><i class="fa fa-gg-circle" :style="{'color': '#66b1ff','margin-right': '5px'}"></i>{{ item.bankName }}</span>-->
<!--      <span style="float: left; color: #8492a6; font-size: 13px; width: 200px;">{{ item.bankAccount }}</span>-->
    </el-option>
  </el-select>
</template>
<script>

import { validatenull } from '@/tdcommon/validate'
import { cusAllName } from '@api/basic/customer'

export default {
  name: 'd2-container-forwarding-unit',
  data () {
    return {
      values: this.value,
      options: [],
      loading: false
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    url: {
      type: String,
      default: () => ''
    },
    allowCreate: {
      type: Boolean,
      default: () => true
    }
  },
  methods: {
    remoteMethod (val, query) {
      this.loading = true
      let searchStr = validatenull(val) ? '' : val
      cusAllName(searchStr).then(response => {
        this.loading = false
        if (response.code === 0) {
          this.options = response.data
        }
      }).catch(() => {
        this.loading = false
      })
    },
    blur (val) {
      this.$emit('blur', val)
    },
    change (val) {
      this.$emit('change', val)
    },
    select (val) {
      this.$emit('select', val)
    },
    handleSelect (val) {
      this.$emit('clickSelect', val)
    },
    visible_change (val) {
      this.$emit('visibleChange', val)
    },
    handleClear (val) {
      this.$emit('handleClear', val)
    }
  },
  watch: {
    values: function (val, oldVal) {
      this.$emit('input', val.toString())
    },
    value: function (val, oldVal) {
      this.values = validatenull(val) ? '' : val
      this.remoteMethod(this.values)
      if (validatenull(this.values)) {
        this.$emit('change', '')
      }
    }
  },
  mounted () {
    this.remoteMethod(this.value)
  }
}
</script>

<style lang="scss" scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-forwarding-fuzzy-all/index.vue"
}
</vue-filename-injector>
